<template>
  <vs-prompt
    title="Add Approvers"
    type="confirm"
    accept-text="Add Approver"
    @cancel="cancelled"
    @accept="accepted"
    @close="cancelled"
    :is-valid="entityAdminIds.length > 0"
    :active.sync="activeSync"
  >
    <div class="select-approver">
      <div>Select merchant users to be added as approvers: &nbsp;</div>
      <div>
        <vs-select
          placeholder="select approvers"
          multiple
          class="select-approver-dropdown"
          v-model="entityAdminIds"
        >
          <vs-select-item
            :key="index"
            :value="user.id"
            :text="user.email"
            v-for="(user, index) of users"
          />
        </vs-select>
      </div>
      <br />
    </div>
  </vs-prompt>
</template>
<script>
export default {
  props: {
    active: Boolean,
    users: Array,
    createApprover: Function,
  },
  data() {
    return {
      activeSync: this.active,
      entityAdminIds: [],
    };
  },
  watch: {
    activeSync: function (val) {
      this.$emit('update:active', val);
    },
    active: function (val) {
      this.activeSync = val;
    },
  },
  mounted() {},
  methods: {
    async cancelled() {
      this.entityAdminIds = [];
    },

    async accepted() {
      // this is to make sure the dialog doesn't disappear before verification happen.
      this.activeSync = true;
      this.createApprover(this.entityAdminIds);
      this.activeSync = false;
    },
  },
};
</script>

<style>
.select-approver {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.select-approver-dropdown {
  height: 38px;
  width: 300px;
  border-radius: 5px;
  margin: 2px 0;
  padding: 0.5rem;
  background-color: white !important;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 1rem;
}
</style>
